import CustomStore from 'devextreme/data/custom_store';
import { apiConfiguration } from '../apiConfig';
import { useContext, useMemo } from 'react';
import TenantContext from '../contexts/tenantContext';
import { FiltriApi } from '../data/apis';


const api = new FiltriApi(apiConfiguration);

/**
 * CustomStore per caricare, inserire e rimuovere i filtri utente del tenant corrente
 */
export function useFiltriDataSource(refreshKey?: number) {
  const { currentTenant } = useContext(TenantContext);

  return useMemo(() => {
    return new CustomStore({
      key: 'id',
      loadMode: 'raw',
      load: (loadOptions) => api.getFiltri({
        tenantId: currentTenant.Id
      }),
      byKey: (key) => api.getFiltroById({
        tenantId: currentTenant.Id,
        filtroId: key
      }),
      update: (key, values) =>
        api.updateFiltro({
          tenantId: currentTenant.Id,
          filtroId: key,
          filtroUpdateDTO: values
        }),
      insert: (values) =>
        api.insertFiltro({
          tenantId: currentTenant.Id,
          filtroCreateDTO: values
        }),
      remove: (key) =>
        api.deleteFiltro({
          tenantId: currentTenant.Id,
          filtroId: key
        }),
    });
  }, [currentTenant.Id, refreshKey]);
}

/**
 * CustomStore per caricare i metadati dei campi del FilterBuilder
 */
export function useFilterBuilderFieldsDataSource() {
  //const api = new FilterBuilderApi(apiConfiguration);
  const { currentTenant } = useContext(TenantContext);

  return useMemo(() => new CustomStore({
    key: 'name',
    loadMode: 'raw',
    load: (loadOptions) =>
      api.getFields({ tenantId: currentTenant.Id })
        .then(dto => dto.columns ?? []),
  }), [currentTenant.Id]);
}

/**
 * CustomStore per caricare i dati di anteprima dal FilterBuilder
 */
export function useAnteprimaDataSource(filterExpression: any) {
  //const api = new FilterBuilderApi(apiConfiguration);
  const { currentTenant } = useContext(TenantContext);

  return useMemo(() => new CustomStore({
    key: 'assistitoId',
    loadMode: 'raw',
    load: (loadOptions) => {
      if (Array.isArray(filterExpression)){
        filterExpression = filterExpression.length === 0 ? "": JSON.stringify(filterExpression)
      }

      console.log(filterExpression);
if (!filterExpression || filterExpression==='') return [];

      return api.getDataFromEspressione({ tenantId: currentTenant.Id, espressione: filterExpression })
        .then(dto => {
          const items = dto.anteprimaItems ?? [];
          return items.map((item, index) => ({
            ...item,
            assistitoId: item.assistitoId || `generated_${index}`
          }));
        
        })}
  }), [currentTenant.Id, filterExpression]);
}

export function useFilterByFilterIdDataSource(filterId?: string) {
  //const api = new FilterBuilderApi(apiConfiguration);
  const { currentTenant } = useContext(TenantContext);

  return useMemo(() => new CustomStore({
    key: 'assistitoId',
    loadMode: 'raw',
    load: (loadOptions) => {
      if (filterId)
        return api.getDataFromFilterId({ tenantId: currentTenant.Id, filtroId: filterId })
          .then(dto => {
            const items = dto.anteprimaItems ?? [];
            return items.map((item, index) => ({
              ...item,
              assistitoId: item.assistitoId || `generated_${index}`
            }));
          })
      else
        return [];
    }
  }), [currentTenant.Id, filterId]);
}

